/**
 * The ONE button used for every consent action (Accept all, Reject all,
 * Customize, Save choices). There is deliberately no `variant` prop so all
 * actions have equal visual weight (GDPR: no nudging). `app-button
 * app-button--secondary` mirrors the main-new-ui class; inside the consent
 * shadow root it is styled by consent.css with the --tc-* tokens.
 */
export const CONSENT_BUTTON_CLASS =
  'app-button app-button--secondary inline-flex min-h-[44px] w-full sm:w-auto sm:min-w-[140px] items-center justify-center rounded-lg border px-4 text-[13px] font-medium'

export interface ConsentButtonProps {
  label: string
  onClick: (e: MouseEvent) => void
  testId?: string
  disabled?: boolean
}

export default function ConsentButton(props: ConsentButtonProps) {
  return (
    <button
      type="button"
      class={CONSENT_BUTTON_CLASS}
      data-testid={props.testId}
      disabled={props.disabled}
      on:click={(e) => props.onClick(e)}
    >
      {props.label}
    </button>
  )
}
